import { UserIcon } from "lucide-react";
import { AnimatedNumber } from "@/components/motion-primitives/animated-number";

export const SeatsCard = ({ seats }: { seats: MedicalFacilitySeats }) => {
  const { openSeats, totalSeats, disclaimer } = seats;
  const openSeatsText =
    openSeats === null
      ? "brak danych o wolnych miejscach szkoleniowych."
      : `${openSeats} – liczba wolnych miejsc szkoleniowych zgłoszonych do ostatniej rekrutacji.`;

  const totalSeatsText =
    totalSeats === null
      ? "brak danych o liczbie akredytowanych miejsc szkoleniowych."
      : `${totalSeats} – łączna liczba akredytowanych miejsc szkoleniowych.`;
  return (
    <div
      className={"flex gap-1"}
      data-title={`${openSeatsText}<br /> ${totalSeatsText}<br /> ${disclaimer}`}
    >
      <UserIcon size={"16px"} />
      <div className="text-sm leading-tight font-normal text-[#1e1926]">
        <span className={""}>
          {openSeats === null ? "b.d." : <AnimatedNumber value={openSeats} />}
        </span>{" "}
        (
        <span className={""}>
          {totalSeats === null ? "b.d." : <AnimatedNumber value={totalSeats} />}
        </span>
        )
      </div>
    </div>
  );
};
